import { ia } from 'lib/helpers/utility';
import { resolveCardIcon } from 'lib/helpers/resolveCardIcon';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';
import Divider from 'components/shared/Divider/Divider';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

import { Caption } from '../../PayWithCardModal/SavedCards';

const SavedCards = ({ cards, active, setActive }) => {
  const { handlePayment, setFieldValue, setSelectedTerminal } = usePaymentContextApi();
  const { terminalData, processor } = usePaymentContext();

  const onToggle = (id) => setFieldValue('methodDetail', id);

  const canEnterCardManually = processor === 'payroc' || !!terminalData?.onlineTerminal;

  const handleCardClickHandler = async () => {
    if (processor === 'payroc') {
      setSelectedTerminal(terminalData?.onlineTerminal || terminalData?.cardPresentTerminal);
      setActive('credit-card');
      return;
    }
    setSelectedTerminal(terminalData?.onlineTerminal);
    await handlePayment();
  };

  return (
    <div className="flex w-full flex-col items-center justify-center gap-8">
      {ia(cards) && (
        <>
          <div className="flex max-h-[300px] w-full flex-col gap-2  overflow-y-auto p-2">
            {cards.map((card) => {
              const isActive = active === card.id;
              return (
                <Disclosure
                  key={card.id}
                  isOpen={isActive}
                  icon={<Icon icon={resolveCardIcon(card.pan)} size="" />}
                  onToggle={(open) => onToggle(open ? card.id : null)}
                  disableOpen
                  caption={<Caption card={card} />}
                  bodyClassName="flex-col"
                  buttonClassName="py-2.5"
                  className="flex-shrink-0"
                  customTitle={
                    <Typography variant="label" size="medium">
                      {card.name}
                    </Typography>
                  }
                />
              );
            })}
          </div>
          <Divider className="w-full" color="neutral-200" text="OR" />
        </>
      )}
      {canEnterCardManually && (
        <Button
          text="Enter card manually"
          icon="credit-card-mono"
          variant="tertiary"
          size="medium"
          color="neutral"
          iconShade={700}
          iconSize={20}
          className="h-10 gap-2 rounded-md border border-solid border-neutral-200 px-3"
          onClick={handleCardClickHandler}
        />
      )}
    </div>
  );
};

export default SavedCards;
